export default __webpack_public_path__ + "static/media/280.2cd01cb8.png";